module.exports = __webpack_public_path__ + "media/images/announceGroup__textBg-2911d496ac4d045ba05649ace62099e0.png";